import { InputLabel, styled } from '@mui/material';

const QInputLabel = styled(InputLabel)({
	fontFamily: 'Inter',
	fontSize: '12px',
	fontWeight: 400
});

export default QInputLabel;
